import { I18n } from 'common/i18n';
import { FilterScope, getAllOption, getScope } from './translations';
import { FilterList, Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import { SelectDropdownConfig } from './filter-config';
import * as filters from 'common/components/AssetBrowser/actions/filters';
import { FilterType } from './types';
import { IBaseListDropdownOption } from '@tylertech/forge/esm/list-dropdown/list-dropdown-constants';

const scope = getScope(FilterScope.Source);

const getSourceOptions = (list?: string[]): IBaseListDropdownOption<string | null>[] => {
  const sources = [getAllOption(scope)];
  list?.forEach((source) => sources.push({ label: source, value: source }));

  return sources;
};

export const sourceConfigs: SelectDropdownConfig = {
  filterName: Filters.Source,
  label: I18n.t('label', { scope }),
  getOptions: getSourceOptions,
  dispatchAction: filters.changeSource,
  filterType: FilterType.SelectDropdown,
  filterListName: FilterList.Sources,
};
